import React from 'react';
import './Signup.css';
import './SeatLegend.css';



//Class to display "Hjelp" button on the seat reservation menu
//Shows modal of legend

export class SeatLegend extends React.Component {
  constructor(props){
    super(props);

    this.closeHelp = this.closeHelp.bind(this);


  }

  
  closeHelp(){
    this.props.showHelp();
  };



  render() {

    const legend = <div className="seatContainer">
      <div className = "legend row">
      <div className="btn seatBox btn-success open">1</div>
      <h6> = Åpen plass, kan velges </h6>
      </div>
      <div className = "legend row">
      <div className="btn seatBox taken">1</div>
      <h6> = Reservert plass, kan ikke velges </h6>
      </div>
      <div className = "legend row">
      <div className="btn seatBox held">1</div>
      <h6> = Noen holder av denne plassen, kan bli ledig. </h6>
      </div>
      <p>Når noen trykker på en plass blir den holdt av i 10 minutter.
        Om den ikke bekreftes reservert innen 10 minutter blir den åpnet igjen </p> 
      </div>
   
    

    return (  
      <div className="Modal">
      {legend}

      <button className="btn btno btn-info help"  onClick={this.closeHelp}>Fortsett</button>
      </div>

    );
  }
}

export default SeatLegend;




// WEBPACK FOOTER //
// ./src/Components/Signup/SeatLegend.js